export default "__VITE_ASSET__CdvFGC4f__"